import classNames from "classnames";
import { SearchProps } from "../BuilderInterface";
import "./style.scss";
import { getCompoundStyle } from "../helpers";
import { SearchNode } from "../../build/types";
import xIcon from "../../assets/x-icon.svg";

import DynamicIcon from "../DynamicIcon";

const staticSearchIcon = (style: React.CSSProperties | undefined) => {
    return (
        <svg
            width={style?.fontSize || "24"}
            height={style?.fontSize || "24"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M19 19L17.0005 17.0005" stroke={style?.color || "#758696"} strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

const staticProductIcon = (style: React.CSSProperties | undefined) => {
    return (
        <svg
            width={style?.fontSize || "24"}
            height={style?.fontSize || "24"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12 11V20" stroke={style?.color || "#758696"} strokeWidth="1.5" strokeLinejoin="round" />
            <path
                d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30205 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M15.5 5.5L8 8.98036V12"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const staticCustomerIcon = (style: React.CSSProperties | undefined) => {
    return (
        <svg
            width={style?.fontSize || "24"}
            height={style?.fontSize || "24"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="9" r="4" stroke={style?.color || "#758696"} strokeWidth="1.5" />
            <path
                d="M6 19L6.0883 18.7351C6.52832 17.4151 6.74832 16.755 7.2721 16.3775C7.79587 16 8.49159 16 9.88304 16H14.117C15.5084 16 16.2041 16 16.7279 16.3775C17.2517 16.755 17.4717 17.4151 17.9117 18.7351L18 19"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

const staticOrderIcon = (style: React.CSSProperties | undefined) => {
    return (
        <svg
            width={style?.fontSize || "24"}
            height={style?.fontSize || "24"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.8125 13.7749H18.4167M16.8125 13.7749C16.0876 13.7749 15.5 14.3625 15.5 15.0874C15.5 15.8123 16.0876 16.3999 16.8125 16.3999H17.5417C18.3471 16.3999 19 16.9875 19 17.7124C19 18.4373 18.3471 18.9995 17.5417 18.9995H16.8125M16.8125 13.7749V12.8999M15.5 18.9995L16.8125 18.9995M16.8125 18.9995V19.8745"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M12.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                stroke={style?.color || "#758696"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const BuilderSearch: React.FC<SearchProps> = ({
    node,
    value,
    inputCallback,
    clickCallback,
    options,
    builderProps
}: SearchProps) => {
    const sNode = node as SearchNode;
    const { attr } = node;

    const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
        if (inputCallback) {
            inputCallback(e.currentTarget.value);
        }
    };

    const handleResetSearch = () => {
        if (inputCallback) {
            inputCallback("");
        }
    };

    const SearchIcon = sNode.icons?.search?.src ? (
        <DynamicIcon name={sNode.icons.search.src} style={sNode.icons.search.style} colors={sNode.icons.search.colors} />
    ) : null;
    const ProductIcon = sNode.icons?.products?.src ? (
        <DynamicIcon name={sNode.icons.products.src} style={sNode.icons.products.style} colors={sNode.icons.products.colors} />
    ) : null;
    const CustomerIcon = sNode.icons?.customers?.src ? (
        <DynamicIcon name={sNode.icons.customers.src} style={sNode.icons.customers.style} colors={sNode.icons.customers.colors} />
    ) : null;
    const OrderIcon = sNode.icons?.orders?.src ? (
        <DynamicIcon name={sNode.icons.orders.src} style={sNode.icons.orders.style} colors={sNode.icons.orders.colors} />
    ) : null;

    const buildSearchClass = classNames("builder-search", {
        [`${attr?.className}`]: !!attr?.className,
        ["search-active"]: value,
        ["builder-mode"]: !!builderProps
    });

    if (builderProps) {
        return (
            <div
                {...attr}
                className={buildSearchClass}
                style={getCompoundStyle({ node })}
                onClick={e => (builderProps?.selectCallback ? builderProps.selectCallback(e, node.id) : {})}
                onMouseMove={e => (builderProps?.outlineCallback ? builderProps.outlineCallback(e, node.id) : {})}
                id={node.id}
                onDragStart={e => builderProps.onDragStart?.(e, node.id)}
                draggable={"true"}
                onDragEnd={builderProps.onDragEnd}
            >
                <div
                    className="input-row"
                    style={{
                        ...sNode.input?.style,
                        ...(options && options.length > 0 ? { borderBottomRightRadius: "0", borderBottomLeftRadius: "0" } : {})
                    }}
                >
                    {SearchIcon ? SearchIcon : staticSearchIcon(sNode.icons?.search?.style)}
                    <input
                        type="text"
                        placeholder={sNode.input?.placeholder || "Start typing or scan to search..."}
                        readOnly
                        value={builderProps?.active ? "Hoodie" : ""}
                        style={sNode.input?.style}
                    />
                    {value && (
                        <button className="reset-search">
                            <img src={xIcon} />
                        </button>
                    )}
                </div>
                {options && options.length > 0 && (
                    <div
                        className="results"
                        style={{
                            ...(builderProps.hovered ? { outline: "2px dashed #2797e8" } : {}),
                            ...(builderProps.selected ? { outline: "2px solid #2797e8" } : {})
                        }}
                    >
                        {options.map((option, index) => (
                            <button key={index} style={sNode.resultStyle}>
                                {option.type === "product" &&
                                    (ProductIcon ? ProductIcon : staticProductIcon(sNode.icons?.products?.style))}
                                {option.type === "customer" &&
                                    (CustomerIcon ? CustomerIcon : staticCustomerIcon(sNode.icons?.customers?.style))}
                                {option.type === "order" && (OrderIcon ? OrderIcon : staticOrderIcon(sNode.icons?.orders?.style))}
                                <p>{option.label} </p>
                            </button>
                        ))}
                    </div>
                )}

                {builderProps.selectedMenu}
            </div>
        );
    } else {
        return (
            <div {...attr} className={buildSearchClass} style={getCompoundStyle({ node })}>
                <div
                    className="input-row"
                    style={{
                        ...sNode.input?.style,
                        ...(options && options.length > 0 ? { borderBottomRightRadius: "0", borderBottomLeftRadius: "0" } : {})
                    }}
                >
                    {SearchIcon ? SearchIcon : staticSearchIcon(sNode.icons?.search?.style)}
                    <input
                        type="text"
                        placeholder={sNode.input?.placeholder || "Start typing or scan to search..."}
                        value={value}
                        onInput={handleInput}
                        style={sNode.input?.style}
                    />
                    {value && (
                        <button className="reset-search" onClick={handleResetSearch}>
                            <img src={xIcon} />
                        </button>
                    )}
                </div>
                {options && options.length > 0 && (
                    <div className="results">
                        {options.map((option, index) => (
                            <button
                                key={index}
                                style={sNode.resultStyle}
                                onClick={() => {
                                    if (clickCallback) clickCallback(option.value, option.type);
                                }}
                            >
                                {option.type === "product" &&
                                    (ProductIcon ? ProductIcon : staticProductIcon(sNode.icons?.products?.style))}
                                {option.type === "customer" &&
                                    (CustomerIcon ? CustomerIcon : staticCustomerIcon(sNode.icons?.customers?.style))}
                                {option.type === "order" && (OrderIcon ? OrderIcon : staticOrderIcon(sNode.icons?.orders?.style))}
                                <p>{option.value} </p>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }
};

export default BuilderSearch;
